module.exports = __webpack_public_path__ + "static/img/12012D_2_3_R_20190716_fit.88f693a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/12012D_2_3_R_20190716_fit.png
// module id = Sanu
// module chunks = 0